"use client";

import { useState } from "react";
import Link from "next/link";
import { formatMXN, getPriceBreakdown } from "@/lib/pricing";
import { useLocalCart } from "@/hooks/use-local-cart";
import ProductArtworkThumbnail from "@/components/product-artwork-thumbnail";

export default function CartButton() {
  const { items, loading, error } = useLocalCart();
  const [open, setOpen] = useState(false);

  return (
    <div className="cart-widget">
      <button
        className="cart-nav-button"
        type="button"
        aria-expanded={open}
        aria-controls="cart-widget-panel"
        onClick={() => setOpen((current) => !current)}
      >
        <span aria-hidden="true">▱</span>
        Carrito
        {!loading && items.length > 0 && (
          <span className="cart-count">{items.length}</span>
        )}
      </button>
      {open && (
        <section
          className="cart-widget-panel"
          id="cart-widget-panel"
          aria-label="Resumen del carrito"
        >
          <div className="cart-widget-heading">
            <strong>Tu carrito</strong>
            <span>{loading ? "…" : `${items.length} artículos`}</span>
          </div>
          {error ? (
            <p className="cart-widget-error" role="alert">{error}</p>
          ) : loading ? (
            <p className="cart-widget-empty" role="status">Cargando carrito…</p>
          ) : items.length ? (
            <>
              <ul className="cart-widget-items">
                {items.slice(0, 3).map((item) => (
                  <li key={item.id}>
                    <div className="cart-widget-item">
                      <ProductArtworkThumbnail
                        item={item}
                        className="cart-widget-thumbnail"
                      />
                      <span className="cart-widget-item-name">{item.product.name}</span>
                    </div>
                    <strong>
                      {formatMXN(
                        getPriceBreakdown(
                          item.product,
                          item.groups,
                          item.selections,
                        ).totalCents,
                      )}
                    </strong>
                  </li>
                ))}
              </ul>
              {items.length > 3 && (
                <p className="cart-widget-more">
                  y {items.length - 3} más
                </p>
              )}
            </>
          ) : (
            <p className="cart-widget-empty">
              Todavía no agregas productos.
            </p>
          )}
          <Link
            className="button button-dark cart-widget-link"
            href="/cart"
            onClick={() => setOpen(false)}
          >
            Ver carrito
          </Link>
        </section>
      )}
    </div>
  );
}
